@let rowData = row();

<article
  class="new-reservation-dialog__location-accordion"
  [class.new-reservation-dialog__location-accordion--expanded]="rowData.expanded"
>
  <button
    type="button"
    class="new-reservation-dialog__location-accordion-header"
    [attr.aria-expanded]="rowData.expanded"
    (click)="onToggle()"
  >
    <span class="new-reservation-dialog__location-accordion-title">
      <strong>{{ rowData.displayName }}</strong>
      @if (rowData.resourceTypeName) {
        <span>{{ rowData.resourceTypeName }}</span>
      }
    </span>

    <cue-icon [icon]="rowData.expanded ? icons.cueArrowUp : icons.cueArrowDown" />
  </button>

  @if (rowData.expanded) {
    <div class="new-reservation-dialog__location-accordion-body">
      <assist-reservation-detail-resource-tab
        [resourceAttendees]="rowData.resourceAttendees"
        [eventStart]="eventStart()"
      />

      @if (ordersEnabled()) {
        <div class="new-reservation-dialog__orders">
          <h3>{{ translation.newReservationUi.locationDetails.orders | transloco }}</h3>

          @if (previousOrdersLoading()) {
            <cue-loading />
          } @else if (rowData.previousOrders.length > 0) {
            <div class="new-reservation-dialog__previous-orders">
              <h4>{{ translation.newReservationUi.locationDetails.previousOrders | transloco }}</h4>

              @for (order of rowData.previousOrders; track order.id ?? order.requestCode ?? $index) {
                <div class="new-reservation-dialog__previous-order">
                  <div class="new-reservation-dialog__previous-order-header">
                    <strong>{{ order.requestCode }}</strong>
                    @if (order.created) {
                      <span>{{ order.created | date: 'short' }}</span>
                    }
                  </div>

                  @if (order.note) {
                    <p class="new-reservation-dialog__previous-order-note">{{ order.note }}</p>
                  }

                  <div class="new-reservation-dialog__order-items">
                    @for (item of order.items; track item.id ?? $index) {
                      <div class="new-reservation-dialog__order-item">
                        <img
                          class="new-reservation-dialog__order-item-image"
                          [src]="getPreviousOrderItemImageUrl(item)"
                          alt=""
                        />

                        <div class="new-reservation-dialog__order-item-main">
                          <strong>{{ getPreviousOrderItemName(item) }}</strong>
                          @if (item.note) {
                            <p>{{ item.note }}</p>
                          } @else {
                            <p class="new-reservation-dialog__hint">
                              {{ translation.newReservationUi.locationDetails.noItemNote | transloco }}
                            </p>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          } @else if (!editable()) {
            <p class="new-reservation-dialog__hint">
              {{ translation.newReservationUi.locationDetails.noOrders | transloco }}
            </p>
          }

          @if (editable()) {
            <div class="new-reservation-dialog__draft-order">
              <h4>{{ translation.newReservationUi.locationDetails.newOrder | transloco }}</h4>

              @if (rowData.orderServicesLoading) {
                <cue-loading />
              } @else if (!rowData.canAddOrders) {
                <p class="new-reservation-dialog__hint">
                  {{ translation.newReservationUi.locationDetails.noOrderServices | transloco }}
                </p>
              } @else {
                @if (rowData.draft.items.length === 0) {
                  <p class="new-reservation-dialog__hint">
                    {{ translation.newReservationUi.locationDetails.newOrderInstruction | transloco }}
                  </p>
                }

                @if (rowData.draft.items.length > 0) {
                  <div class="new-reservation-dialog__field">
                    <label>{{ translation.newReservationUi.locationDetails.orderNote | transloco }}</label>
                    <textarea
                      cueRtl
                      class="new-reservation-dialog__textarea"
                      [value]="rowData.draft.note"
                      (input)="onOrderNoteChange($any($event.target).value)"
                    ></textarea>
                  </div>
                }

                <div class="new-reservation-dialog__order-items">
                  @for (item of rowData.draft.items; track item.clientId) {
                    <div class="new-reservation-dialog__order-item">
                      <img
                        class="new-reservation-dialog__order-item-image"
                        [class.new-reservation-dialog__order-item-image--cover]="item.imagePreferCover"
                        [style.object-position]="item.imageObjectPosition"
                        [src]="item.imageUrl || 'assets/images/placeholder-order.svg'"
                        alt=""
                      />

                      <div class="new-reservation-dialog__order-item-main">
                        <strong>{{ item.name }}</strong>

                        @if (item.noteAllowed) {
                          <label class="new-reservation-dialog__order-note-label">
                            {{ translation.newReservationUi.locationDetails.itemNote | transloco }}
                          </label>
                          <textarea
                            cueRtl
                            class="new-reservation-dialog__textarea"
                            [class.new-reservation-dialog__textarea--invalid]="isOrderItemNoteInvalid(item)"
                            [value]="item.note"
                            (input)="onOrderItemNoteChange(item.clientId, $any($event.target).value)"
                          ></textarea>
                          @if (isOrderItemNoteInvalid(item)) {
                            <p class="new-reservation-dialog__validation">
                              {{
                                translation.newReservationUi.locationDetails.noteMinLength
                                  | transloco: { length: item.noteMinLength }
                              }}
                            </p>
                          }
                        }
                      </div>

                      <cue-button
                        type="delete"
                        [icon]="icons.cueDelete"
                        btnClass="autowidth new-reservation-dialog__icon-cue-button"
                        [title]="translation.newReservationUi.locationDetails.removeOrderItem | transloco"
                        (click)="onRemoveOrderItem($event, item.clientId)"
                      />
                    </div>
                  }
                </div>

                @if (rowData.addingOrderItem) {
                  <assist-service-select
                    type="event"
                    [eventDate]="eventStart()"
                    [resourceGuid]="rowData.resource.id"
                    [usedServiceIds]="rowData.usedServiceIds"
                    (cancelled)="onSetAddingOrderItem(false)"
                    (itemSelected)="onOrderServiceSelected($event)"
                  />
                } @else {
                  <cue-button
                    type="secondary"
                    btnClass="autowidth new-reservation-dialog__inline-button"
                    [icon]="icons.cueAdd"
                    (click)="onAddOrderItem($event)"
                  >
                    {{ translation.newReservationUi.locationDetails.addOrderItem | transloco }}
                  </cue-button>
                }
              }
            </div>
          }
        </div>
      }
    </div>
  }
</article>
